<template>
  <div>
    <!-- Affichage d'une barre de progression pendant le chargement des données -->
    <load-progress :condition="!dataLoaded" label="Chargement des données"></load-progress>
    <!-- Affichage du tree view et des éditeurs selon l'objet sélectionné -->

    <div v-if="dataLoaded">
        <fiche-container ref="FICHE_CONTAINER"
                         :fiche="selectedFiche"
                         :route="notifRoute"
                         :attribut="attribut"
                         :route-element="routeElement"
                         @back="back"
                         @selectItem="selectItem">
        </fiche-container>
    </div>
    <div v-for="(button, index) in extraButtons" :key="index">
      <loader-button class="ms-2"
                     :outlined="button.outlined"
                     @callback="button.callback()"
                     :label="button.label"
                     :disabled="button.disabled">
      </loader-button>
    </div>
    <section-container :dialogOpen="showWizard"
                       :section="sectionWizard"
                       @closeDialog="hideWizard">
    </section-container>
  </div>
</template>

<script lang="ts">
  import { defineComponent, markRaw, type PropType } from "vue";
  import LoadProgress from '@/framework/base/components/LoadProgress.vue';
  import {
    storeSession,
    storeUser,
    storeAdresse,
    storeCivilite,
    storeContact,
    storeMail,
    storeNotif,
    storeNumero,
    storeRib,
    storeSalarie
  } from '@/generated/stores';
  import { CiRouter } from '@/framework/base/helpers/NavHelper';
  import Route from '@/generated/classes/Route';
  import ModuleBase from '@/framework/base/components/ModuleBase';
  import FicheSalarieListExtend from '@/extend/fiches/FicheSalarieListExtend.vue';
  import SectionSalarieListExtend from '@/extend/sections/SectionSalarieListExtend.vue';
  import FicheSalarieAbstractExtend from '@/extend/fiches/FicheSalarieAbstractExtend.vue';
  import SectionSalarieIdentiteAbstractExtend from '@/extend/sections/SectionSalarieIdentiteAbstractExtend.vue';
  import SectionSalarieCoordonneesAbstractExtend from '@/extend/sections/SectionSalarieCoordonneesAbstractExtend.vue';
  import SectionSalarieInfoComplementairesAbstractExtend from '@/extend/sections/SectionSalarieInfoComplementairesAbstractExtend.vue';
  import SectionSalarieEtatCivilAbstractExtend from '@/extend/sections/SectionSalarieEtatCivilAbstractExtend.vue';
  import SectionSalarieRibAbstractExtend from '@/extend/sections/SectionSalarieRibAbstractExtend.vue';
  import FicheSalarieExtend from '@/extend/fiches/FicheSalarieExtend.vue';
  import SectionSalarieExtend from '@/extend/sections/SectionSalarieExtend.vue';
  import SectionAdresseExtend from '@/extend/sections/SectionAdresseExtend.vue';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import Owner from '@/generated/classes/Owner';
  import SectionSalarieCiviliteExtend from '@/extend/sections/SectionSalarieCiviliteExtend.vue';
  import SectionSalarieInformationsExtend from '@/extend/sections/SectionSalarieInformationsExtend.vue';
  import SectionSalarieFiscaliteExtend from '@/extend/sections/SectionSalarieFiscaliteExtend.vue';
  import SectionRibExtend from '@/extend/sections/SectionRibExtend.vue';
  import { Fiches, Modules, Sections } from '@/generated/classes/AppSchema';
  import { GenModule, RessourceGenModule } from '@/generated/ressources/generatedRessources';
  import Wizard from '@/extend/classes/Wizard';
  import Section from '@/framework/base/classes/Section';
  import SectionWizard from '@/framework/wizard/components/SectionWizard.vue';
  import Fiche from '@/framework/base/classes/Fiche';
  import { RouteElements } from '@/framework/base/classes/Section';
  import User from '@/generated/classes/User';
  import FicheContainerAbstract from "@/framework/base/components/FicheContainerAbstract.vue";

  export function ModuleSalarieOpenFiche(route: Route | undefined): RouteElements {
    const section = new Section();
    const fiche = new Fiche();
    if (route && route.fiche) {
      switch (route.fiche) {
        case Fiches.SALARIE_LIST: {
          fiche.component = FicheSalarieListExtend;
          fiche.type = 'salarie'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSalarie.createNewSalarie();
            } else {
              fiche.data = storeSalarie.getSalarie(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.SALARIE_ABSTRACT: {
          fiche.component = FicheSalarieAbstractExtend;
          fiche.type = 'salarie'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSalarie.createNewSalarie();
            } else {
              fiche.data = storeSalarie.getSalarie(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.SALARIE: {
          fiche.component = FicheSalarieExtend;
          fiche.type = 'salarie'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSalarie.createNewSalarie();
            } else {
              fiche.data = storeSalarie.getSalarie(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.CONTAINER: {
          fiche.component = FicheContainerAbstract;
          fiche.type = 'salarie'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSalarie.createNewSalarie();
            } else {
              fiche.data = storeSalarie.getSalarie(route.ficheObjId);
            }
          }
          break;
        }
      }
    } else {
      fiche.component = FicheSalarieListExtend;
      fiche.type = 'salarie'
      if (route && route.ficheObjId != null) {
        if (route.ficheObjId == 0) {
          fiche.data = storeSalarie.createNewSalarie();
        } else {
          fiche.data = storeSalarie.getSalarie(route.ficheObjId);
        }
      }
    }
    if (route && route.section && route.section != Sections.NONE) {
      switch (route.section) {
        case Sections.SALARIE_LIST: {
          section.component = SectionSalarieListExtend;
          section.type = 'salarie'
          if (route.sectionObjId == 0) {
            section.data = storeSalarie.createNewSalarie();
          } else {
            section.data = storeSalarie.getSalarie(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.SALARIE_IDENTITE_ABSTRACT: {
          section.component = SectionSalarieIdentiteAbstractExtend;
          section.type = 'salarie'
          if (route.sectionObjId == 0) {
            section.data = storeSalarie.createNewSalarie();
          } else {
            section.data = storeSalarie.getSalarie(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.SALARIE_COORDONNEES_ABSTRACT: {
          section.component = SectionSalarieCoordonneesAbstractExtend;
          section.type = 'salarie'
          if (route.sectionObjId == 0) {
            section.data = storeSalarie.createNewSalarie();
          } else {
            section.data = storeSalarie.getSalarie(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT: {
          section.component = SectionSalarieInfoComplementairesAbstractExtend;
          section.type = 'salarie'
          if (route.sectionObjId == 0) {
            section.data = storeSalarie.createNewSalarie();
          } else {
            section.data = storeSalarie.getSalarie(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.SALARIE_ETAT_CIVIL_ABSTRACT: {
          section.component = SectionSalarieEtatCivilAbstractExtend;
          section.type = 'salarie'
          if (route.sectionObjId == 0) {
            section.data = storeSalarie.createNewSalarie();
          } else {
            section.data = storeSalarie.getSalarie(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.SALARIE_RIB_ABSTRACT: {
          section.component = SectionSalarieRibAbstractExtend;
          section.type = 'salarie'
          if (route.sectionObjId == 0) {
            section.data = storeSalarie.createNewSalarie();
          } else {
            section.data = storeSalarie.getSalarie(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.SALARIE: {
          section.component = SectionSalarieExtend;
          section.type = 'salarie'
          if (route.sectionObjId == 0) {
            section.data = storeSalarie.createNewSalarie();
          } else {
            section.data = storeSalarie.getSalarie(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.ADRESSE: {
          section.component = SectionAdresseExtend;
          section.type = 'adresse'
          if (route.sectionObjId == 0) {
            section.data = storeAdresse.createNewAdresse();
          } else {
            section.data = storeAdresse.getAdresse(route.sectionObjId);
          }
          section.data.owner = new Owner();
          section.data.owner.objType = ObjTypes.SALARIE;
          if (route.ficheObjId) {
            section.data.owner.objId = route.ficheObjId;
          }
          section.showButton = true;
          break;
        }
        case Sections.SALARIE_CIVILITE: {
          section.component = SectionSalarieCiviliteExtend;
          section.type = 'salarie'
          if (route.sectionObjId == 0) {
            section.data = storeSalarie.createNewSalarie();
          } else {
            section.data = storeSalarie.getSalarie(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.SALARIE_INFORMATIONS: {
          section.component = SectionSalarieInformationsExtend;
          section.type = 'salarie'
          if (route.sectionObjId == 0) {
            section.data = storeSalarie.createNewSalarie();
          } else {
            section.data = storeSalarie.getSalarie(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.SALARIE_FISCALITE: {
          section.component = SectionSalarieFiscaliteExtend;
          section.type = 'salarie'
          if (route.sectionObjId == 0) {
            section.data = storeSalarie.createNewSalarie();
          } else {
            section.data = storeSalarie.getSalarie(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.RIB: {
          section.component = SectionRibExtend;
          section.type = 'rib'
          if (route.sectionObjId == 0) {
            section.data = storeRib.createNewRib();
          } else {
            section.data = storeRib.getRib(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
      }
    }
    if (fiche && fiche.component) {
      fiche.component = markRaw(fiche.component);
    }
    if (section && section.component) {
      section.component = markRaw(section.component);
    }
    const res = new RouteElements();
    res.fiche = fiche;
    res.section = section;
    return res;
  }

  export default defineComponent({
    extends: ModuleBase,
    components: {
      LoadProgress,
    },

    props: {
    },

    created (): void {
      if (this.route) {
        this.notifRoute = this.route;
      }
      const session = storeSession.connectedUser;
      if (session) {
        const user = storeUser.getUser(session.id);
        if (user.modules.includes(Modules.SALARIE)) {
          this.wizardDone = true;
        }
      }
      if (!this.wizardDone) {
        Wizard.showWizard(Modules.SALARIE).then((res) => {
          if (res.id > 0) {
            this.wizard = res;
            this.showWizard = true;
          } else {
            User.acceptCgu(true);
            this.wizardDone = true;
          }
        })
      }
      this.loadStores();
    },

    data() {
      const attribut: unknown = undefined;
      const route = CiRouter.getRoute();
      return {
        wizard: new Wizard(),
        attribut,
        notifRoute: new Route(),
        route,
      }
    },

    computed: {
      ressource () {
        return RessourceGenModule(GenModule.MODULE_SALARIE);
      },
      sectionWizard (): Section {
        const section = new Section();
        section.component = SectionWizard;
        section.data = this.wizard;
        section.helper = true;
        return section;
      },

      storesLoaded (): boolean {
        return true;
      },

      dataLoaded (): boolean {
        const res = this.wizardDone && this.storesLoaded
        if (res && this.init) {
          this.setInit(false);
          if (!this.route) {
            this.selectItem(this.route);
          }
          CiRouter.setRouteChangedSelector(this.routeChanged);
        }
        return res;
      }
    },

    methods: {
      loadStores() : void{
        // Load and register events on used server classes
        storeAdresse.registerAdresse();
        storeCivilite.registerCivilite();
        storeContact.registerContact();
        storeMail.registerMail();
        storeNotif.registerNotif();
        storeNumero.registerNumero();
        storeRib.registerRib();
        storeSalarie.registerSalarie();
      },
      setInit(value: boolean) : void{
        this.init = value;
      },
      routeChanged (route: Route): void {
        this.selectItem(route);
      },
      selectItem(route: Route | undefined): void {
        const routeElement = ModuleSalarieOpenFiche(route);
        this.routeElement = routeElement;
        this.selectedFiche = routeElement.fiche;
        this.selectedFiche.ressourceHeader = this.ressource;
        if (route) {
          this.notifRoute = route;
          if (route && route.attribut) {
            this.attribut = route.attribut;
          } else {
            this.attribut = undefined;
          }
          if (route.section && route.section != Sections.NONE) {
            this.lastShowSection = !this.lastShowSection;
            this.selectedFiche.showSection = this.lastShowSection;
          }
        }
        const index = this.lastSelectedFiche.findIndex(item => {
          return item.component === this.selectedFiche.component;
        })
        if (index >= 0) {
          this.lastRoutes.splice(index + 1)
          this.lastSelectedFiche.splice(index + 1)
        } else {
          this.lastRoutes.push(route);
          this.lastSelectedFiche.push(this.selectedFiche);
        }
      }
    }
  })
</script>
